import styled from 'styled-components';

export const Container = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9999;
  background-color: rgba(0, 0, 0, 0.8);

  strong {
    font-weight: bold;
  }
`;

export const ModalOverlay = styled.div`
display: flex;
position: fixed;
top: 0;
left: 0;
width: 100vw;
height: 100%;
  
justify-content: center;
align-items: center;
overflow-y: auto;

@media (max-width: 740px) {
  padding: 10px;
  align-items: flex-start;
}
`;

export const ModalContent = styled.div`
  position: relative;
  background-color: #000000;
  border: 2px solid #00FF00;
  border-radius: 10px;
  max-width: 700px;
  width: 90vw;
  max-height: 90vh;
  overflow-y: auto;
  padding: 0px 20px 20px 20px;
  margin: auto;
  
  
  /* Scrollbar customizada */
  &::-webkit-scrollbar {
    width: 3px;
  }
  
  &::-webkit-scrollbar-track {
    background: #1a1a1a;
  }
  
  &::-webkit-scrollbar-thumb {
    background: #00FF00;
    border-radius: 4px;
  }
  
  @media (max-width: 740px) {
    padding: 0px 15px 15px 15px;
    border-radius: 8px;
    max-height: 95vh;
    margin-top: 10px;
    margin-right:30px ;
  }
  
  @media (max-width: 480px) {
    padding: 0px 10px 10px 10px;
  }
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 10px;
  right: 10px;
  background-color: #FF0000;
  color: white;
  border: none;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  font-size: 18px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  
  &:hover {
    background-color: #CC0000;
  }
`;

export const DownloadButton = styled.button`
  position: absolute;
  top: 10px;
  right: 50px;
  background-color: #00FF00;
  color: #000000;
  border: none;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  font-size: 18px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  transition: all 0.3s ease;
  
  &:hover {
    background-color: #00CC00;
    transform: scale(1.1);
  }
  
  &:active {
    transform: scale(0.95);
  }
  
  @media (max-width: 740px) {
    right: 45px;
    width: 28px;
    height: 28px;
    font-size: 16px;
  }
  
  @media (max-width: 480px) {
    right: 45px;
    width: 26px;
    height: 26px;
    font-size: 14px;
  }
`;

export const CotacaoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  color: white;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 10px;
  border-bottom: 2px solid #00FF00;
  
  @media (max-width: 740px) {
    text-align: center;
    padding: 15px 10px;
    gap: 15px;
  }
`;

export const LogoSection = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const LogoMain = styled.div`
  display: flex;
  align-items: center;
  margin-left:100px ;
  
  @media (max-width: 740px) {
    font-size: 32px;
    margin-left:0 ;
  }
  
  @media (max-width: 480px) {
    font-size: 28px;
  }
`;

export const InfoSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  text-align: left;
`;

export const InfoItem = styled.div`
  font-size: 14px;
  font-weight: bold;
  color: white;
  
  @media (max-width: 740px) {
    font-size: 11px;
  }
  
  @media (max-width: 480px) {
    font-size: 10px;
  }
`;

export const VehicleInfo = styled.div`
  padding: 15px;
  background-color: #1a1a1a;
  border-radius: 5px;
  text-transform: uppercase;
  
  p {
    margin: 5px 0;
    font-size: 14px;
    line-height: 1.6;
  }

  @media (max-width: 740px) {
    padding: 12px;
    
    p {
      font-size: 13px;
      line-height: 1.5;
    }
  }
  
  @media (max-width: 480px) {
    padding: 10px;
    
    p {
      font-size: 12px;
      line-height: 1.4;
    }
  }
`;

export const SectionTitle = styled.div`
  background-color: #00FF00;
  color: #000000;
  padding: 12px 20px;
  font-size: 18px;
  font-weight: bold;
  border-radius: 10px;
  text-align: center;
  margin-top: 10px;
  
  @media (max-width: 740px) {
    padding: 10px 15px;
    font-size: 16px;
    border-radius: 10px;
  }
  
  @media (max-width: 480px) {
    padding: 8px 12px;
    font-size: 14px;
    border-radius: 10px;
  }
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  background-color: #1a1a1a;
  font-size: clamp(10px, 5vw, 12px);
  
  tbody tr {
    border-bottom: 1px solid #333;
    
    &:last-child {
      border-bottom: none;
    }
  }
`;

export const Table_2 = styled.td`
  padding: 12px 15px;
  /* font-size: 13px; */
  color: white;
  border-right: 1px solid #333;
  text-align: ${props => props.center ? 'center' : 'left'};
  word-wrap: break-word;
  
  &:last-child {
    border-right: none;
  }
  
  &:nth-child(2) {
    width: 150px;
  }
  
  &:nth-child(3) {
    width: 100px;
  }
  
  @media (max-width: 740px) {
    padding: 10px 8px;
    /* font-size: 11px; */
    
    &:nth-child(2) {
      width: 100px;
    }
    
    &:nth-child(3) {
      width: 70px;
    }
  }
  
  @media (max-width: 480px) {
    padding: 8px 5px;
    /* font-size: 10px; */
    
    &:nth-child(2) {
      width: 80px;
    }
    
    &:nth-child(3) {
      width: 60px;
    }
  }
`;

export const ConsultorInfo = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 15px;
  background-color: #1a1a1a;
  border-radius: 5px;
  flex-wrap: wrap;
  gap: 10px;
  
  @media (max-width: 740px) {
    flex-direction: column;
    padding: 12px;
    gap: 8px;
  }
  
  @media (max-width: 480px) {
    padding: 10px;
  }
`;

export const ConsultorItem = styled.div`
  font-size: 14px;
  font-weight: bold;
  color: white;
  text-transform: uppercase; ;
  
  @media (max-width: 740px) {
    font-size: 13px;
  }
  
  @media (max-width: 480px) {
    font-size: 12px;
  }
`;
